<script>
import PageCarFileList from 'components/pages/carfile/PageCarFileList'
import HistoryDetail from 'components/pages/carfile/detail/HistoryDetail'
import PageCarRail from 'components/pages/PageCarRail'
import PageOrganiseList from 'components/pages/organise/PageOrganiseList'
// import PageOrganiseCreate from 'components/pages/organise/PageOrganiseCreate'
import PageSearchCar from 'components/pages/PageSearchCar'
import PageSetting from 'components/pages/PageSetting'
import PageStatistic from 'components/pages/PageStatistic'
import PageAlarmPlanList from 'components/pages/alarmplan/PageAlarmPlanList'
import PageBulletin from 'components/pages/PageBulletin'
import PageCarFileDetail from 'components/pages/carfile/PageCarFileDetail'
import PageDeviceDetail from 'components/pages/devicedetail/PageDeviceDetail'
import PageOperator from 'components/pages/operator/PageOperator'
import PageAuthorityList from 'components/pages/authority/PageAuthorityList'
import PageAreaAlarmHome from 'components/pages/vehiclealarm/areaalarm/PageAreaAlarmHome'
import PageAreaAlarmOut from 'components/pages/vehiclealarm/areaalarm/PageAreaAlarmOut'
import PageAreaAlarmRange from 'components/pages/vehiclealarm/areaalarm/PageAreaAlarmRange'
import PageAreaAlarmStraight from 'components/pages/vehiclealarm/areaalarm/PageAreaAlarmStraight'
import PageStatusAlarmFire from 'components/pages/vehiclealarm/statusalarm/PageStatusAlarmFire'
import PageStatusAlarmOnline from 'components/pages/vehiclealarm/statusalarm/PageStatusAlarmOnline'
import PageStatusAlarmOffline from 'components/pages/vehiclealarm/statusalarm/PageStatusAlarmOffline'
import PageStatusAlarmOver from 'components/pages/vehiclealarm/statusalarm/PageStatusAlarmOver'
import PageStatusAlarmStop from 'components/pages/vehiclealarm/statusalarm/PageStatusAlarmStop'
import PageEffectAlarmFake from 'components/pages/vehiclealarm/effectalarm/PageEffectAlarmFake'
import PageEffectAlarmDis from 'components/pages/vehiclealarm/effectalarm/PageEffectAlarmDis'
import PageEffectAlarmPulldown from 'components/pages/vehiclealarm/effectalarm/PageEffectAlarmPulldown'
import PageEffectAlarmPosition from 'components/pages/vehiclealarm/effectalarm/PageEffectAlarmPosition'
import PageDriveAlarmTired from 'components/pages/vehiclealarm/drivealarm/PageDriveAlarmTired'
import PageDriveAlarmInterval from 'components/pages/vehiclealarm/drivealarm/PageDriveAlarmInterval'
import PageDriveAlarmOver from 'components/pages/vehiclealarm/drivealarm/PageDriveAlarmOver'
import PageDriveAlarmLimit from 'components/pages/vehiclealarm/drivealarm/PageDriveAlarmLimit'
import PageFaultAlarmPowerLow from 'components/pages/vehiclealarm/faultalarm/PageFaultAlarmPowerLow'
import PageFaultAlarmNum from 'components/pages/vehiclealarm/faultalarm/PageFaultAlarmNum'
import PageFaultAlarmOilLow from 'components/pages/vehiclealarm/faultalarm/PageFaultAlarmOilLow'
import PageFaultAlarmOilTime from 'components/pages/vehiclealarm/faultalarm/PageFaultAlarmOilTime'
import PageFaultAlarmOilEvery from 'components/pages/vehiclealarm/faultalarm/PageFaultAlarmOilEvery'

import PageLogList from 'components/pages/systemlog/PageLogList'

import PageNoticeList from 'components/pages/notice/PageNoticeList'
import PageNoticeRelease from 'components/pages/notice/PageNoticeRelease'
import PageAlarmHandleList from 'components/pages/alarmhandle/PageAlarmHandleList'
import PageAlarmPlanHome from 'components/pages/alarmplan/PageAlarmPlanHome'
import PageAlarmPlanDetail from 'components/pages/alarmplan/PageAlarmPlanDetail'
import PageVehicleTrace from 'components/pages/vehicletrace/PageVehicleTrace'
import PageVehicleMonitor from 'components/pages/vehiclemonitor/PageVehicleMonitor'
import PageVehicleMaster from 'components/pages/vehiclemaster/PageVehicleMaster'
import PagePosDeviceList from 'components/pages/posdevice/PagePosDeviceList'

import PageSystemMenuList from 'components/pages/systemmenu/PageSystemMenuList'
import PageDeviceTypeList from 'components/pages/devicetype/PageDeviceTypeList'
import PageDeviceDirectiveList from 'components/pages/devicedirective/PageDeviceDirectiveList'
import PageDictionaryList from 'components/pages/dictionary/PageDictionaryList'
import PageVersionHistoryList from 'components/pages/versionhistory/PageVersionHistoryList'
import PageDeviceProtocolList from 'components/pages/deviceprotocol/PageDeviceProtocolList'
import PageBatDirectiveHistoryList from 'components/pages/devicedirective/PageBatDirectiveHistoryList'
import PageDeviceInstruction from 'components/pages/deviceinstruction/PageDeviceInstruction'
import PageVehicleBrandEdit from 'components/pages/vehiclebrand/PageVehicleBrandEdit'

import PageRouteMonitorVehicle from 'components/pages/didivehiclemonitor/PageRouteMonitorVehicle'
import PageFenceMonitorVehicle from 'components/pages/didivehiclemonitor/PageFenceMonitorVehicle'

import PageRescueServiceOrderList from 'components/pages/rescueservice/PageRescueServiceOrderList'
import PageRescueServiceOrderEdit from 'components/pages/rescueservice/PageRescueServiceOrderEdit'

import PageRescureImportList from 'components/pages/rescureimport/PageRescureImportList'
import PageRescureImportEdit from 'components/pages/rescureimport/PageRescureImportEdit'

import PageRescueDriverList from 'components/pages/rescuedrive/PageRescueDriverList'
import PageRescueDriverEdit from 'components/pages/rescuedrive/PageRescueDriverEdit'
import PageRescueDriveOrderDetail from 'components/pages/rescuedrive/PageRescueDriveOrderDetail'
import PageRescuePriceList from 'components/pages/rescuedrive/PageRescuePriceList'
import PageRecoverCar from 'components/pages/carfile/PageRecoverCar'

import PageDriveStatisticsList from 'components/pages/rescuecompanystatistics/PageDriveStatisticsList'
import PageDistrictSpreadList from 'components/pages/rescuecompanystatistics/PageDistrictSpreadList'
import PageCompanyStatisticsList from 'components/pages/rescuecompanystatistics/PageCompanyStatisticsList'

import PageDriveMonthStatisticsList from 'components/pages/rescuecompanystatistics/PageDriveMonthStatisticsList'
import PageCompanyMonthStatisticsList from 'components/pages/rescuecompanystatistics/PageCompanyMonthStatisticsList'
import PageVersioning from 'components/pages/versioning/PageVersioning'

import PageBillingMangeMent from 'components/pages/billingmanagement/PageBillingMangeMent'
import PageAccountCheckTodidi from 'components/pages/accountcheck/PageAccountCheckTodidi'
import PageAccountCheckToGroup from 'components/pages/accountcheck/PageAccountCheckToGroup'
import PageAccountCheckToRb from 'components/pages/accountcheck/PageAccountCheckToRb'
import PageBillingList from 'components/pages/billingmanagement/PageBillingList'

// 迪迪专用的模块
import PageMonitorVehicle from 'components/pages/didivehiclemonitor/PageMonitorVehicle'
import PageTraceVehicle from 'components/pages/didivehicletrace/PageTraceVehicle'
import PageFileCarList from 'components/pages/didicarfile/PageFileCarList'
import PageFileCarDetail from 'components/pages/didicarfile/PageFileCarDetail'
// 结算管理
import PagePaymentList from 'components/pages/paymentList/PagePaymentList' 
import PagePaymentListEdit from 'components/pages/paymentList/PagePaymentListEdit'  

// 运维管理
import PageCostFeedback from 'components/pages/rescueservice/PageCostFeedback' 

export default {
  name: 'ContentTab',
  components: {
    PageCarFileList,
    PageCarRail,
    PageOrganiseList,
		//	PageOrganiseCreate,
    PageSearchCar,
    PageSetting,
    PageStatistic,
    PageAlarmPlanList,
    PageBulletin,
    PageCarFileDetail,
    PageDeviceDetail,
    PageOperator,
    PageAuthorityList,
    PageAreaAlarmHome,
    PageAreaAlarmOut,
    PageAreaAlarmRange,
    PageAreaAlarmStraight,
    PageStatusAlarmFire,
    PageStatusAlarmOnline,
    PageStatusAlarmOffline,
    PageStatusAlarmOver,
    PageStatusAlarmStop,
    PageEffectAlarmFake,
    PageEffectAlarmDis,
    PageEffectAlarmPulldown,
    PageEffectAlarmPosition,
    PageDriveAlarmTired,
    PageDriveAlarmInterval,
    PageDriveAlarmOver,
    PageDriveAlarmLimit,
    PageFaultAlarmPowerLow,
    PageFaultAlarmNum,
    PageFaultAlarmOilLow,
    PageFaultAlarmOilTime,
    PageFaultAlarmOilEvery,

    PageLogList,
    PageNoticeList,
    PageNoticeRelease,
    PageAlarmHandleList,
    PageAlarmPlanHome,
    PageVehicleTrace,
    PageVehicleMonitor,
    PageVehicleMaster,
    PagePosDeviceList,
    PageAlarmPlanDetail,

    PageRouteMonitorVehicle,
    PageFenceMonitorVehicle,
    PageDeviceTypeList,
    PageDeviceDirectiveList,
    PageDeviceInstruction,
    PageVersionHistoryList,
    PageVehicleBrandEdit,
    PageDictionaryList,
    PageBatDirectiveHistoryList,
    PageRescueServiceOrderList,
    PageRescueServiceOrderEdit,

    PageRescureImportList,
    PageRescureImportEdit,

    PageRescueDriverList,
    PageRescueDriverEdit,
    PageRescueDriveOrderDetail,
		    PageRescuePriceList,
		    HistoryDetail,
		    PageRecoverCar,
		    PageDriveStatisticsList,
		    PageDistrictSpreadList,
		    PageCompanyStatisticsList,
		    PageDeviceProtocolList,
		    PageSystemMenuList,
		    PageVersioning,
		    PageDriveMonthStatisticsList,
		    PageCompanyMonthStatisticsList,
		    PageBillingMangeMent,
		    // 迪迪专用的模块
    PageMonitorVehicle,
    PageTraceVehicle,
    PageFileCarList,
    PageFileCarDetail,
    PageAccountCheckTodidi,
    PageAccountCheckToGroup,
    PageAccountCheckToRb,
    PageBillingList,
    PagePaymentList,
    PagePaymentListEdit,
    PageCostFeedback
  },
  data () {
    return {

    }
  },
  computed: {
    tabList () {
      return this.$store.state.home.tabList
    },
    selected () {
      return this.$store.state.home.currentIndex
    }
  },
  updated () {
			// console.log(this.selected)
  },
		// functional:true,
  render: function (h) {
			// alert('render')
    const tabList = this.tabList
 			const tabSelect = this.selected
	 		let children = []
	 		function addTab () {
	 			for (let i = 0, length = tabList.length; i < length; i++) {
		 			if (tabList[i].No === tabSelect) {
		 				children.push(h(tabList[i].id, {style: {display: 'block'}, key: tabList[i].No}))
		 			} else {
		 				children.push(h(tabList[i].id, {style: {display: 'none'}, key: tabList[i].No}))
		 			}
	 			}
	 			return children
	 		}
	  		return h('div', {style: {width: '100%', height: '100%', position: 'relative'}, 'class': {childComp: true}}, addTab())
	  		// return h('div',{domProps:{innerHTML:'baz'}})
  		}
}
</script>



// WEBPACK FOOTER //
// ContentTab.vue?74b002f2